import { Component } from '@angular/core';

@Component({
	selector: 'bb-table-container',
	templateUrl: './bb-table-container.component.html',
	styleUrls: ['./bb-table-container.component.scss']
})

export class BbTableContainerComponent {}
